/**
 * Route catalog setter for the navigate_to tool.
 *
 * The host app (frontend) calls setRouteCatalog() once at companion bootstrap
 * with the text generated by routeCatalogPromptText() from the frontend's
 * route-catalog module. edge-ai never hard-codes app routes — it only stores
 * and surfaces what the host provides.
 *
 * Mirrors the setNodeCatalog / setGroundingProvider injection pattern.
 */

let injectedCatalog: string | null = null

/** Inject the app's route catalog text (called once by the host app). */
export function setRouteCatalog(catalog: string): void {
  injectedCatalog = catalog
}

/**
 * The route catalog to include in the system prompt.
 * Returns null when the host app has not called setRouteCatalog yet.
 */
export function getRouteCatalog(): string | null {
  return injectedCatalog
}
